<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Gast Management
  section.modal-card-body
    b-tabs(v-model="tabIndex" type="is-boxed" position="is-centered")

      b-tab-item(label="Gast suchen" icon="text-box-outline")
        b-field(label="Suche")
          b-input(v-model="searchString")
        b-table(:data="searchResults"
              default-sort-direction="asc"
              default-sort="firstName"
              :selected.sync="selected"
              hoverable)
          b-table-column(field='id' label='ID' width='40' sortable centered v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.firstName }}
          b-table-column(field='lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.lastName }}
          b-table-column(field='address.city' label='Stadt' sortable v-slot="props")
            | {{ props.row.address.city }}
          b-table-column(field='address.email' label='E-Mail' sortable v-slot="props")
            | {{ props.row.address.email }}
          b-table-column(field='createdAt' label='Gast seit' sortable centered v-slot="props")
            | {{ new Date(props.row.createdAt).toLocaleDateString() }}
      
      b-tab-item(label="Gast anlegen" icon="text-box-outline")
        ValidationObserver(ref="form")
          .generic-wrapper
            .container
              .two-column
                .column
                  .form
                    h2.title.is-6 Allgemein
                    ValidationProvider(name="Anrede" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Anrede" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-select(v-model="formData.salutation")
                          option(value="Frau") Frau
                          option(value="Herr") Herr
                    ValidationProvider(name="Vorname" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Vorname" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.firstName")
                    
                    ValidationProvider(name="Nachname" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Nachname" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.lastName")

                    b-field(label="Geburtstag" label-position="on-border")
                      v-date-picker(:columns="2" v-model="formData.birthday")
                        template(v-slot='{ inputValue, inputEvents }')
                          input.input(:value='inputValue' v-on='inputEvents')

                    b-field(label="Kommentar zum Gast" label-position="on-border")
                      b-input(type="textarea" v-model="formData.comment")
                .column
                  .form
                    h2.title.is-6 Adresse
                    //- b-field(label="Zeile 1" label-position="on-border")
                    //-   b-input(v-model="formData.address.line1")

                    b-field(label="Zeile 2" label-position="on-border")
                      b-input(v-model="formData.address.line2")
                    
                    ValidationProvider(name="Straße und HausNr." rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Straße und HausNr." label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.street")
                    
                    b-field(grouped)
                      ValidationProvider(name="PLZ" rules="required" v-slot="{ errors, valid }") 
                        b-field(label="PLZ" label-position="on-border"
                                :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                          b-input(v-model="formData.address.zip")
                      .spacer.sm
                      ValidationProvider(name="Stadt" rules="required" v-slot="{ errors, valid }") 
                        b-field(label="Stadt" label-position="on-border"
                                :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                          b-input(v-model="formData.address.city")

                    ValidationProvider(name="Land" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Land" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.country")

                  .form.margin-top
                    h2.title.is-6 Kontakt
                    ValidationProvider(name="E-Mail" rules="required|email" v-slot="{ errors, valid }") 
                      b-field(label="E-Mail" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.email")
                    ValidationProvider(name="Alternative E-Mail" rules="email" v-slot="{ errors, valid }") 
                      b-field(label="Alternative E-Mail" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.email2")
                    ValidationProvider(name="Mobiltelefon" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Mobiltelefon" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.mobile")
                    ValidationProvider(name="Telefon" rules="" v-slot="{ errors, valid }") 
                      b-field(label="Telefon" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-input(v-model="formData.address.phone")

  footer.modal-card-foot(v-if="tabIndex === 0")
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-primary(@click="$emit('selectCustomer', selected); $emit('close')" :disabled="!selected") {{selected && selected.firstName ? selected.firstName : ''}} Auswählen
  footer.modal-card-foot(v-else)
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-primary(@click="createCustomer()") Gast anlegen
</template>

<script>
import { DateTime } from "luxon"

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchResults: [],
      selected: null,
      searchString: "",
      tabIndex: 0,
      formData: {
        salutation: null,
        firstName: null,
        lastName: null,
        birthday: null,
        comment: "",
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          email2: null,
          phone: null,
          mobile: null
        }
      }
    };
  },
  async mounted() {
    this.updateSearch();
  },
  watch: {
    searchString() {
      this.selected = null
      this.updateSearch()
    }
  },
  methods: {
    async updateSearch() {
      this.searchResults = await this.$store.dispatch("customers/search", {searchString: this.searchString})
    },
    createCustomer() {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        this.formData.birthday = DateTime.fromJSDate(this.formData.birthday).toISODate();
        const newCustomer = await this.$store.dispatch("customers/create", this.formData);
        this.$emit('selectCustomer', newCustomer);
        this.$emit('close');

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}
</style>